import * as yup from "yup";
const required="thisFieldIsRequired";
export const createBookingSchema = (v, t, isEditMode) => {
  return yup.object().shape({
    

    cityId: v.string().required(t(required)),
    categoryId: v.string().required(t(required)),
    tripId: v.string().required(t(required)),
    packageId: v.string().required(t(required)),
    customerId: v.string().required(t(required)),

    noOfPeople: v
      .number()
      .typeError(t(required))
      .required(t(required)),

    bookingDate: v.string().required(t(required)),
    startTime: v.string().required(t(required)),
  
  });
};